import svgRaw from './logo.svg?raw';

const markup = svgRaw
  .replace('width="270" height="270" ', '')
  .replaceAll('fill="black"', 'fill="currentColor"')
  .replace('<svg ', '<svg aria-hidden="true" focusable="false" ');

export interface LogoMarkProps {
  className?: string | undefined;
}

export function LogoMark({ className }: LogoMarkProps) {
  return (
    <span
      className={className ?? 'size-6 [&_svg]:size-full [&_svg]:block'}
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
}

/**
 * Знак Glory на плашке: чёрная собака на белом фоне — так знак выглядит везде (решение владельца 2026-10-10), и на
 * тёмном меню, и в светлой теме. Размер плашки задаёт `className`, знак занимает три четверти.
 */
export function LogoBadge({ className }: LogoMarkProps) {
  return (
    <span
      className={
        className ??
        'inline-grid size-8 shrink-0 place-items-center rounded-md bg-white text-[#0D0D0D] ring-1 ring-black/10'
      }
    >
      <LogoMark className="size-3/4 [&_svg]:block [&_svg]:size-full" />
    </span>
  );
}
